module.exports = __webpack_public_path__ + "static/homepage_desktop_flow-991b6d15007d24b5af7dbbabd89b737f.png";